<template>
    <div>
        <main class="flex flex-col overflow-scroll border-gray-200 border rounded-2xl p-2 bg-white" :key="key">
            <div class="ml-2 flex" v-if="user == null">
                Loading user data....
            </div>
            <div class="mx-2" v-else>
                <div class="text-lg">Current sessions :</div>
                <div v-for="(sessions,ip) in sessionIps">
                    <div class="font-bold text-lg ml-2">
                        <span>IP address :</span>
                        <span class="ml-1" v-text="ip"></span>
                    </div>
                    <div v-for="session in sessions" class="">
                        <div class="flex items-baseline ml-4">
                            <div class="font-medium text-xs text-gray-400 w-32">Session:</div>
                            <div class="font-medium mx-1 whitespace-nowrap" v-text="session.id"></div>
                            <div class="font-medium text-gray-400 w-20 text-right text-sm mx-1 whitespace-nowrap">expires at</div>
                            <div class="font-medium mx-0 whitespace-nowrap" v-text="format(session.expires)"></div>
                            <div class="font-semibold ml-4 text-xs text-gray-600" v-if="currentSession === session.id"><span class="fa fa-arrow-alt-left text-green-500"></span> Current Session</div>
                        </div>
                        <div v-for="connection in session.connections" class="flex items-baseline ml-8">
                            <div class="font-medium text-xs text-gray-400 w-32 whitespace-nowrap">Websocket:</div>
                            <div class="font-medium mx-1 whitespace-nowrap" v-text="connection.id"></div>
                            <div class="font-medium text-gray-400 w-20 text-right text-sm mx-1 whitespace-nowrap">expires at</div>
                            <div class="font-medium mx-0 whitespace-nowrap" v-text="format(connection.expires)"></div>
                            <div class="font-semibold ml-4 text-xs text-gray-600" v-if="currentConnection === connection.id"><span class="fa fa-arrow-alt-left text-green-500"></span> Current Websocket Connection</div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <div class="flex mt-4 w-full">
            <div class="flex-1">
                <ui-button-new class="items-baseline" icon="fas fa-sign-out" @click="logout" danger>Logout everywhere <span class="font-bold text-xs ml-2" v-text="canLogout?'(click again to log out)':''"></span></ui-button-new>
                <div class="text-xs text-gray-400 mt-2">This will log you out of ALL current sessions, including this page you are currently on.</div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import User from "../../services/User";
import {cloneDeep} from "lodash";
import UiButton from "../ui/UiButton.vue";

export default {
    components: {UiButton},
    props: [],
    data() {
        return {
            user: null,
            currentConnection: null,
            currentSession: null,
            key: 0,
            sessionIps: {},
            logoutTimeout:false,
            canLogout:false,
        }
    },
    watch: {
        user: {
            handler(newValue, oldValue) {
                this.setSessionIps();
            },
            deep: true,
        },
    },
    computed: {},
    methods: {
        format(dateTime) {
            return moment(dateTime).format("HH:mm:ss [on] DD-MM-YYYY");
        },
        async logout() {
            if (!this.canLogout) {
                this.canLogout = true
                this.logoutTimeout = setTimeout(() => {
                    this.canLogout = false
                },3000)
                return
            }
            await Http.put(route('api.v2.organization.user.full-logout'));
        },
        setSessionIps() {
            this.user = User.user;
            if (User.connectionId) {
                this.currentConnection = User.connectionId;
                this.currentSession = User.getSessionId()
            }
            this.sessionIps = {}
            if (this.user && this.user.sessions) {
                this.user.sessions.forEach((s) => {
                    let session = cloneDeep(s);
                    this.user.connections.forEach((connection) => {
                        if (connection.sessionId === session.id) {
                            if (!session.connections) {
                                session.connections = []
                            }
                            session.connections.push(connection)
                        }
                    })
                    if (!this.sessionIps[session.ipAddress]) {
                        this.sessionIps[session.ipAddress] = []
                    }
                    this.sessionIps[session.ipAddress].push(session)
                })
            }
            this.key++;
        },
        updateUserFromListener(event) {
            this.setSessionIps();
        },
    },
    async mounted() {
        await User.register();
        this.setSessionIps()
        User.registerAggregate({"type": 'User', 'id': this.user.id}, this.updateUserFromListener)
    }
}
</script>
